import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const GreenThumbsUpIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="50" height="50" viewBox="0 0 512 512">
		<g transform="translate(0 0.39)">
			<circle cx="256" cy="256" r="256" transform="translate(0 -0.39)" fill="#2cbf50" opacity="0.15" />
			<g transform="translate(116.816 126.084)">
				<path
					d="M38.474,157.145A11.164,11.164,0,0,1,27.2,145.872v-.151a11.273,11.273,0,0,1,22.547,0A11.486,11.486,0,0,1,38.474,157.145ZM75.451,23.668A27.689,27.689,0,0,0,63.426,11.493C57.714,8.637,50.2,8.637,35.167,8.637H31.71c-9.921,0-14.881,0-18.789,1.954a18.09,18.09,0,0,0-7.967,8.117C3,22.466,3,27.426,3,37.5v115.74c0,9.921,0,15.032,1.954,18.789a18.085,18.085,0,0,0,7.967,8.117c3.908,1.8,8.869,1.8,18.789,1.8h3.457c15.031,0,22.547,0,28.259-2.706a27.685,27.685,0,0,0,12.025-12.175A22.844,22.844,0,0,0,77.4,160.9c.9-5.11.9-11.875.9-22.1V51.777c0-12.626,0-19.841-1.8-25.253A16.024,16.024,0,0,0,75.451,23.668Z"
					transform="translate(0 72.666)"
					fill="#1c7c51"
					fillRule="evenodd"
				/>
				<path
					d="M182.353,119.23A35.709,35.709,0,0,0,166.72,103.6C159.2,99.84,150.036,99.84,131.4,99.84H104.481a6.155,6.155,0,0,1-5.806-8c10.059-32.616,10.834-57.7,2.208-72.866a28.071,28.071,0,0,0-19.54-14.43c-5.562-1.2-12.626-2.255-18.188-.15C54.587,7.7,52.783,15.966,51.281,22.579,46.35,44.838,32.968,75.152,12.745,89.388a7.247,7.247,0,0,0-2.886,7.388c1.588,7.526,1.588,16.1,1.588,27.716v87.031c0,10.68,0,18.772-1.147,25.807a6.575,6.575,0,0,0,3.761,7.195l16.325,6.831c4.06,1.653,6.014,2.556,8.118,3.157a60.612,60.612,0,0,0,6.012,1.2c2.255.151,4.359.151,8.719.151h66.136c9.771,0,14.582,0,19.241-1.2a35.871,35.871,0,0,0,12.176-5.562c4.058-2.705,7.364-6.614,13.528-13.829l7.365-8.418c5.11-6.012,7.665-8.868,9.619-12.476a36.015,36.015,0,0,0,3.909-10.371c.751-3.908.751-7.966.751-15.933v-33.52C185.961,135.915,185.961,126.746,182.353,119.23Z"
					transform="translate(89.407)"
					fill="#1c7c51"
					fillRule="evenodd"
					opacity="0.4"
				/>
			</g>
		</g>
	</svg>
);
